import React from 'react';
import {Box, MenuItem, Select, Typography} from "@mui/material";
import {FontSelectObjDto} from "../../dtos";
import {FONTS_ARRAY_FOR_SELECT} from "../../globals";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface IFontSelector {
    onChange: (value: string) => void;
    fontName: FontSelectObjDto;
}

const FontsSelect: React.FC<IFontSelector> = ({
                                                  onChange,
                                                  fontName,
                                              }) => {


    const onFontChange = (item: any) => {
        onChange(item.target.value);
    };

    const frameTypeSelectOptions = FONTS_ARRAY_FOR_SELECT.map((font, index) => {
        return (
            <MenuItem value={font.value} key={`${font.value}${index}`} sx={{
                padding: `12px 8px`,
            }}>
                <Box sx={{
                    display: `flex`,
                    alignItems: `center`,
                    height: "24px",
                    width: "100%"
                }}>
                    <Typography fontWeight={400} fontFamily={font.value.toLowerCase()}>{font.label}</Typography>
                </Box>
            </MenuItem>

        )
    })

    return (
        <Select
            displayEmpty
            value={fontName.value}
            onChange={onFontChange}
            IconComponent={KeyboardArrowDownIcon}
            inputProps={{'aria-label': 'Without label'}}
            sx={{
                width: `100%`,
                // height: `38px`,
                border: `1px solid #d1d7db`,
                '& legend': {display: 'none'},
                '& fieldset': {
                    top: 0,
                    border: `none`,
                },
                '& > .MuiSelect-select': {
                    padding: `12px 8px`
                }
            }}
            MenuProps={{
                PaperProps: {
                    sx: {
                        "& .MuiMenuItem-root.Mui-selected": {
                            backgroundColor: "#C7C6C1!important",
                            '& .MuiTypography-root': {
                                color: `#ffffff`,
                            }
                        },
                        "& .MuiMenuItem-root:hover": {
                            backgroundColor: "#999DA0",
                            '& .MuiTypography-root': {
                                color: `#ffffff`,
                            }
                        },
                        "& .MuiMenuItem-root.Mui-selected:hover": {
                            backgroundColor: "#818380!important",
                            '& .MuiTypography-root': {
                                color: `#ffffff`,
                            }
                        }
                    }
                },
                MenuListProps: {
                    sx: {
                        padding: "4px 0",
                        maxHeight: "264px",
                    }
                }
            }}
        >
            {frameTypeSelectOptions}
        </Select>
    )

}

export default FontsSelect;